// extracted by mini-css-extract-plugin
export default {"shutterstockWidgetContainer":"ShutterstockWidgetBlock_shutterstockWidgetContainer__PIfoX"};